import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  MenuItem,
  Chip,
  Box,
  Typography
} from '@mui/material';

class IntegrationReactSelectNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      single: props.someText || '',
      multi: [],
    };
  }

  componentDidMount() {
    if (this.props.haveDefault) {
      const defaultValues = this.props.defaultValue.map((xx) => xx.label);
      this.setState(
        { single: this.props.multipleSelect ? [] : defaultValues[0], multi: defaultValues },
        () => {
          this.props.onSelect(this.props.multipleSelect ? this.state.multi : this.state.single);
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.reRenderComponent && prevProps.reRenderComponent !== this.props.reRenderComponent) {
      this.setState({ single: '', multi: [] });
    }
  }

  handleChange = (event) => {
    const { value } = event.target;
    if (this.props.disableEvent) return;

    if (this.props.multipleSelect) {
      this.setState({ multi: value }, () => {
        this.props.onSelect(value);
      });
    } else {
      this.setState({ single: value }, () => {
        this.props.onSelect(value);
      });
    }
  };

  render() {
    const { multipleSelect, content, IntegrationReactSelectNewLabel, placeholder, errorText } = this.props;
    const suggestions = content.map((item) => item.label);

    return (
      <Box>
        <TextField
          fullWidth
          select
          variant="standard"
          SelectProps={{
            multiple: multipleSelect,
            renderValue: (selected) => {
              if (multipleSelect) {
                return (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                );
              }
              return selected;
            },
          }}
          label={IntegrationReactSelectNewLabel?.toUpperCase()}
          value={multipleSelect ? this.state.multi : this.state.single}
          onChange={this.handleChange}
          placeholder={placeholder || ''}
          error={!!errorText}
          helperText={errorText}
        >
          {suggestions.map((label, index) => (
            <MenuItem key={index} value={label}>
              {label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    );
  }
}

IntegrationReactSelectNew.propTypes = {
  someText: PropTypes.string,
  content: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  haveDefault: PropTypes.bool,
  defaultValue: PropTypes.array,
  reRenderComponent: PropTypes.bool,
  disableEvent: PropTypes.bool,
  multipleSelect: PropTypes.bool,
  placeholder: PropTypes.string,
  IntegrationReactSelectNewLabel: PropTypes.string,
  errorText: PropTypes.string,
};

export default IntegrationReactSelectNew;

